const CommonDropdown = ({
  options,
  value,
  onChange,
  label,
  className,
  custum,
  text,
  id,
  page,
}) => {
  const isDisabled = value === "specialist";

  // Conditional styling based on the page prop
  const isUserPage = page === "user";

  return (
    <div className={`flex flex-col ${className}  cursor-pointer`}>
      {label && <label className="text-[12px] font-bold mb-1">{label}</label>}
      <div className="relative">
        <select
          id={id}
          value={value}
          onChange={onChange}
          className={`border ${
            isUserPage
              ? "p-1 border-gray-400 rounded-md h-7 text-[blue] text-[12px]"
              : "p-1 border-1 border-blue-600 rounded-lg text-[blue] text-[12px]"
          }  my-2 w-full appearance-none bg-white pl-4 pr-10`}
          style={{
            borderWidth: isUserPage ? "1px" : "1.5px",
            ...custum,
            ...text,
          }}
          disabled={isDisabled}
        >
          {options.map((option, index) => (
            <option key={index} value={option.value} className="border-none">
              {option.label}
            </option>
          ))}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-blue-600">
          {/* Dropdown Icon */}
          <svg className="fill-current h-4 w-4" viewBox="0 0 20 20">
            <path d="M7 10l5 5 5-5H7z" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default CommonDropdown;
